import React from 'react';

export default function BackButton(props) {

    const {func, customStyles} = props;

    const defaultStyles = " flex flex-row justify-end text-white pr-4  sm:pr-8 gap-4 text-3xl hover:opacity-60 transition-opacity duration-300"

    const styles = (customStyles ? customStyles : defaultStyles )

    return (
        <div className={`${styles}`}>
            <i onClick={func} className="ri-arrow-go-back-line text-gold-accent cursor-pointer"></i>
            <div onClick={func} className={`cursor-pointer`}>Back</div>
        </div>
    );
}

